import React from "react";
import { Button, CircularProgress, useTheme, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const buttonBaseStyles = {
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  px: 2,
  py: 1,
};

const BulkDownloadButton = ({ selectedCount, isDownloading, onDownload }) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={
        selectedCount === 0
          ? "Please select at least one employee to download evidence"
          : ""
      }
      arrow
      placement="top"
    >
      <span>
        <Button
          onClick={onDownload}
          disabled={isDownloading || selectedCount === 0}
          startIcon={
            isDownloading ? (
              <CircularProgress size={16} sx={{ color: "white" }} />
            ) : null
          }
          sx={{
            ...buttonBaseStyles,
            bgcolor: "#3B82F6",
            color: "#fff",
            minWidth: 160,
            flexShrink: 0,
            "&:hover": { bgcolor: "#2563EB" },
            "&:disabled": {
              bgcolor: theme.customColors?.background?.light || "#E5E7EB",
              color: theme.customColors?.text?.disabled || "#9CA3AF",
            },
            whiteSpace: "nowrap",
          }}
        >
          {isDownloading
            ? "Downloading..."
            : selectedCount > 0
              ? `Download Evidence (${selectedCount})`
              : "Download Evidence"}
        </Button>
      </span>
    </Tooltip>
  );
};

export default BulkDownloadButton;
